import { makeAutoObservable } from 'mobx';

class PaginationState {
  paginationUpdated;
  hidePaginationInfo;

  pagination;

  constructor({pagination, paginationUpdated, hidePaginationInfo}) {
    makeAutoObservable(this);

    this.pagination = pagination;
    this.paginationUpdated = paginationUpdated;
    this.hidePaginationInfo = hidePaginationInfo;
  }

  async nextPage() {
    if (!this.nextEnabled) return;

    await this.paginationUpdated({
      currentPage: this.pagination.currentPage + 1
    });
  }

  async prevPage() {
    if (!this.prevEnabled) return;

    await this.paginationUpdated({
      currentPage: this.pagination.currentPage - 1
    });
  }

  updatePagination(pagination) {
    this.pagination = pagination;
  }

  get startEntryIndex() {
    return (this.pagination.currentPage - 1) * this.pagination.pageSize + 1;
  }

  get endEntryIndex() {
    return Math.min(
      this.pagination.currentPage * this.pagination.pageSize,
      this.pagination.totalCount
    );
  }

  get visible() {
    return !!this.pagination.totalCount &&
      (this.buttonsVisible || !this.hidePaginationInfo);
  }

  get buttonsVisible() {
    return this.nextEnabled || this.prevEnabled;
  }

  get nextEnabled() {
    return this.pagination.currentPage < this.pagination.totalPages;
  }

  get prevEnabled() {
    return this.pagination.currentPage > 1;
  }
}

export default PaginationState;
